import classNames from "classnames";
import { FC } from "react";
import styles from './checkboxGroup.module.scss';

const CheckboxGroup: FC<CheckboxGroupProps> = (props: CheckboxGroupProps) => {
    const {checked, label, disabled, className, onChange} = props


    return (
        <div className={classNames(`${styles.container}`, className)}>
            <label>
                <input
                    id="checkbox"
                    type="checkbox"
                    disabled={disabled ? disabled : false}
                    onChange={(event) => onChange && onChange(event.target.checked)}
                />
                <img
                    src={
                        checked
                            ? "/icons/checkbox_checked.svg"
                            : "/icons/checkbox_unchecked.svg"
                }
                    alt="icon"
                />
                {label && (
                    <p className={styles.label}>{label}</p>
                )}
            </label>
        </div>
    );
};

export interface CheckboxGroupProps {
    checked: boolean | null;
    label?: string;
    disabled?: boolean;
    className?: string;
    onChange?: (value: boolean) => void;
}

export default CheckboxGroup;